import React, { useState } from 'react';
import { X } from 'lucide-react'; // Or FaTimes from react-icons/fa if you prefer

const NewKeyModal = ({ isOpen, onClose, onCreateKey }) => {
  const [key, setKey] = useState('');
  const [comment, setComment] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreateKey({ key, comment }); // Pass key and comment to parent
    setKey(''); // Clear form fields
    setComment('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-800 bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-5 border-b border-slate-100">
          <h3 className="text-xl font-semibold text-slate-800">New key</h3>
          <button
            onClick={onClose}
            className="text-slate-800 hover:text-slate-600 transition-colors"
            aria-label="Close modal"
          >
            <X size={24} /> {/* Using Lucide-React for the close icon */}
          </button>
        </div>

        {/* Modal Body (Form) */}
        <form onSubmit={handleSubmit} className="p-5 space-y-5">
          <div>
            <label htmlFor="key" className="block text-slate-800 text-sm font-medium mb-1">
              Key
            </label>
            <input
              type="text"
              id="key"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              className="w-full p-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 text-slate-800 bg-slate-100"
              placeholder="Enter your OpenAI API key"
              required
            />
          </div>

          <div>
            <label htmlFor="comment" className="block text-slate-800 text-sm font-medium mb-1">
              Comment
            </label>
            <textarea
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows="3"
              className="w-full p-3 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 text-slate-800 bg-slate-100 resize-y"
              placeholder="Add an optional comment for this key"
            ></textarea>
          </div>

          {/* Modal Footer (Create Button) */}
          <div className="pt-4">
            <button
              type="submit"
              className="w-full bg-blue-500 text-white font-semibold py-3 px-6 rounded-md hover:bg-blue-600 transition-colors shadow-md"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewKeyModal;